import Countdown from 'react-countdown'
import { useTranslation } from 'react-i18next'
import useSWR from 'swr'
import { useWeb3React } from '@web3-react/core'
import { useUpdaterChainId } from '~/hooks'
import { getStakingCoolDownRemainSeconds } from '~/apis'
import CommonTipsContent from './CommonTipsContent'
import { StyledLonUnlockCountdownContainer } from '../styled'

interface Props {
  onClickRedeem: () => void
  onCloseModal: () => void
}

const LonUnlockCountDown: React.FC<Props> = ({
  onCloseModal,
  onClickRedeem,
}) => {
  const { t } = useTranslation()
  const { account } = useWeb3React()
  const chainId = useUpdaterChainId()

  const { data: remainingSeconds } = useSWR(
    ['getStakingCoolDownRemainSeconds', chainId, account],
    () => getStakingCoolDownRemainSeconds(chainId, account),
  )
  const countdownTime = Date.now() + remainingSeconds * 1000

  return (
    <StyledLonUnlockCountdownContainer>
      <p className="countdown-title">{t('unlock_countdown_title')}</p>
      <span className="tips">{t('unlock_countdown_subTitle')}</span>
      <Countdown
        date={countdownTime}
        renderer={({ days, hours, minutes, seconds }) => (
          <section className="count-down-time-area">
            <span className="time-area day">{days}</span>
            <span className="days">{t('days')}</span>
            <span className="time-area">{hours > 9 ? hours : `0${hours}`}</span>
            <span className="colon">:</span>
            <span className="time-area">
              {minutes > 9 ? minutes : `0${minutes}`}
            </span>
            <span className="colon">:</span>
            <span className="time-area">
              {seconds > 9 ? seconds : `0${seconds}`}
            </span>
          </section>
        )}
        autoStart
        key={countdownTime}
      />
      <section className="description">
        <p>{t('unlock_countdown_tips1')}</p>
        <p>{t('unlock_countdown_tips2')} </p>
        <p>{t('unlock_countdown_tips3')}</p>
      </section>
      <CommonTipsContent />
      {Number(remainingSeconds) > 0 ? (
        <section className="bottom-btn-area">
          <button className="force-redeem-btn" onClick={onClickRedeem}>
            {t('force_redeem')}
          </button>
          <button className="keep-waiting-btn" onClick={onCloseModal}>
            {t('keep_waiting')}
          </button>
        </section>
      ) : (
        <section className="bottom-btn-area">
          <button className="redeem-immediate-btn" onClick={onClickRedeem}>
            {t('redeem_immediately')}
          </button>
        </section>
      )}
    </StyledLonUnlockCountdownContainer>
  )
}

export default LonUnlockCountDown
